export default {"src":"/_next/static/media/youtube.357fef64.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};